import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=04e5678c&scoped=true"
import script from "./resource.vue?vue&type=script&lang=js"
export * from "./resource.vue?vue&type=script&lang=js"
import style0 from "./resource.vue?vue&type=style&index=0&id=04e5678c&prod&lang=less&scoped=true"
import style1 from "./resource.vue?vue&type=style&index=1&id=04e5678c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e5678c",
  null
  
)

export default component.exports